// extracted by mini-css-extract-plugin
export default {"section":"styles_section__fEdd8","container":"styles_container__jpsoL"};